export const formatNumber = (numb: number | string, isDecimal = false) => {
  const formatter = new Intl.NumberFormat('fi-FI');

  if (isDecimal) {
    return formatter.format(parseFloat(numb.toString()));
  }

  return formatter.format(parseInt(numb.toString()));
};
